import React from 'react';
import { Form } from 'react-bootstrap';
import { FormSelect, FormNumber } from '~/components/FormControl';
import { COMPARED_OPTIONS } from '~/config/constants';

function DvComparedDetail() {
    return (
        <Form.Row className="justify-content-between">
            <FormSelect
                name="dvComparedDetail.dvCompareOption"
                options={COMPARED_OPTIONS || []}
                sm={5}
                tooltip="Comparison of player's DV to opponent's."
            />
            <FormNumber
                name="dvComparedDetail.dvCompareValue"
                min={0}
                max={12}
                sm={5}
                tooltip="Comparison of player's DV difference and opponent's."
            />
        </Form.Row>
    );
}

export default DvComparedDetail;
